import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  private apiUrl = environment.WS_URL + '/api/v1/data';

  constructor(private http: HttpClient) { }

  getAuditLog(table_name:string, table_id:string, id:string): Observable<any> {
    return this.http.get<any>(this.apiUrl + '/audit-log/?table_name=' + table_name + '&table_id=' + table_id + '&id=' + id);
  }
}